import { ref, computed, watch, readonly } from 'vue'
import { useHead } from '@vueuse/head'

import { useCore } from '@/composables/core/index.js'

import { PAGE_TITLE, DEFAULT_PAGE_DESCRIPTION } from './consts.js'
import { generateHrefLangsForCurrentRoute } from './utils.js'

let head = null

export function useHeader () {
  const { store, t } = useCore()
  const currentRoute = computed(() => store.state.app.currentRoute)

  const hrefLangs = ref([])

  const pageTitle = computed(() => {
    return currentRoute.value?.meta?.pageTitle
      ? `${PAGE_TITLE} - ${t(currentRoute.value?.meta?.pageTitle)}`
      : PAGE_TITLE
  })

  const pageDescription = computed(() => {
    return currentRoute.value?.meta?.description
      ? t(currentRoute.value?.meta?.description)
      : DEFAULT_PAGE_DESCRIPTION
  })

  const initialize = () => {
    if (head) return

    useHead({
      title: pageTitle,
      meta: [
        {
          name: 'description',
          content: pageDescription,
        },
      ],
      link: hrefLangs,
    })

    watch(currentRoute, (newVal, oldVal) => {
      if (newVal?.path !== oldVal?.path) {
        hrefLangs.value = newVal?.meta?.generateHrefLangs
          ? generateHrefLangsForCurrentRoute()
          : []
      }
    }, { immediate: true })
  }

  return {
    initialize,
    pageTitle,
    pageDescription,
    hrefLangs: readonly(hrefLangs),
  }
}
